import axios from '../../utils/axios';

export default function fetchLGCollection(adminId, params = {}) {
    return (
        axios.get(`/admin/${adminId}/allLGCollections`,  {params} )
    )
}
